import React from 'react';
import { Card as MuiCard, Theme, SxProps } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { ClientConfigState } from '../../../services/redux/clientConfigSlice';

interface CardProps {
  children: React.ReactNode;
  expressConfig?: any;
  sx?: SxProps<Theme>;
}

const productCardStyles = (
  theme: Theme,
  customPrimaryColor?: string,
): SystemStyleObject<Theme> => ({
  padding: theme.spacing(3),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  cursor: 'pointer',
  transition: 'all 0.3s ease-in-out',
  background: 'white',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: '0 12px 20px rgba(0,0,0,0.1)',
    borderColor: customPrimaryColor || theme.palette.primary.main,
  },
});

const Card = ({ children, expressConfig, sx }: CardProps) => {
  const theme = useTheme();

  // Get expressConfig from Redux
  const expressConfigObject = expressConfig
    ? expressConfig
    : useSelector(
        (state: { clientConfiguration: ClientConfigState }) =>
          state.clientConfiguration.configs,
      );

  // Get custom primary color from expressConfig if available
  const customPrimaryColor = expressConfigObject?.pruffConnect_styles_mainColor;

  return (
    <MuiCard
      sx={{ ...productCardStyles(theme, customPrimaryColor), ...(sx || {}) }}
    >
      {children}
    </MuiCard>
  );
};

export default Card;
